export default __webpack_public_path__ + "static/media/jane.70b83c65.svg";